import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Button } from "@mui/material";
import React from "react";
import Header from "../../../chat/Header/Header";

interface LeadContactsHeaderProps {
  onMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
}

const LeadContactsHeader: React.FC<LeadContactsHeaderProps> = ({
  onMenuOpen,
}) => {
  return (
    <Box sx={{ height: "60px", flexShrink: 0, position: "relative" }}>
      <Header title="Contatos de Leads" />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          right: 16,
          transform: "translateY(-50%)",
          display: "flex",
          gap: 1,
        }}
      >
        <Button
          variant="contained"
          size="small"
          endIcon={<ExpandMoreIcon />}
          onClick={onMenuOpen}
          sx={{
            px: 1.5,
            py: 0.5,
            fontSize: "11px",
            borderRadius: "4px",
            backgroundColor: "#00a884",
            textTransform: "none",
            fontWeight: 500,
            minWidth: "auto",
            height: "28px",
            "&:hover": {
              backgroundColor: "#008f6f",
            },
            "& .MuiButton-endIcon": {
              marginLeft: "4px",
              fontSize: "14px",
            },
          }}
        >
          Ações
        </Button>
      </Box>
    </Box>
  );
};

export default LeadContactsHeader;
